import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { NewInquiryFormValues } from '../Add/AddNewInquiryFormWrapper';


type Props = {
  formikProps: FormikProps<NewInquiryFormValues>;
  onClose: () => void;
  formType :'Add' | 'Update'

};

const NewInquiryForm = ({ formikProps, onClose , formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'>{formType} Contact</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
        <div>
          <ATMTextField
            name='name'
            value={values.name}
            onChange={(e) => {
              setFieldValue('name', e.target.value);
            }}
            label='Name'
             placeholder='Enter Name'
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name='mobile'
            value={values?.mobile}
            onChange={(e) => {
              setFieldValue('mobile', e.target.value);
            }}
            label='Mobile'
            placeholder='Enter Mobile Number'
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name='email'
            value={values?.email}
            onChange={(e) => {
              setFieldValue('email', e.target.value);
            }}
            label='Email'
            placeholder='Enter Email'
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default NewInquiryForm;